import _ from 'lodash';
import PathDecomposer from './decomposePath';
import CalculatePathPosition from './calculatePathPosition';
import { IGNORE, UNUSED } from '../../PCBHelper';
import auroraDBJson from '../../Designs/auroraDbData';
import compTableHelper from '../helper/compTableHelper';
import { getCompType } from '../../Designs/compTypeHelper';
import { SIERRA } from '../../../constants/pageType';
import { getInterfaceSetupInfo } from './setupHelper';

class SchematicTreeData {
  constructor() {
    this.data = new Map(); //id ->verificationId, data -> interface data and schematic branch data
    /*  this.treeTempData = {
       "pcbId": "4435489278288",
       "log": [
         {
           "text": "",
           "type": "title"
         }
       ],
       "root": [
         "U1"
       ],
       "lengthUnit": "mil",
       "branch": [
         {
           "signal": "SCL",
           "path": [
             {
               "length": "100",
               "net": "IIC_MAIN_SCL_LS",
               "start": {
                 "name": "U1",
                 "pin": "J24"
               },
               "end": {
                 "name": "A1",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SCL_LS",
               "start": {
                 "name": "A1",
                 "pin": ""
               },
               "end": {
                 "name": "R325",
                 "pin": "2"
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SCL_LS",
               "start": {
                 "name": "A1",
                 "pin": ""
               },
               "end": {
                 "name": "U77",
                 "pin": "3"
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "U77",
                 "pin": "6"
               },
               "end": {
                 "name": "A2",
                 "pin": ""
               }
             },
             {
               "length": "300",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A2",
                 "pin": ""
               },
               "end": {
                 "name": "A3",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A3",
                 "pin": ""
               },
               "end": {
                 "name": "U80",
                 "pin": "18"
               }
             },
             {
               "length": "80",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A3",
                 "pin": ""
               },
               "end": {
                 "name": "A4",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A4",
                 "pin": ""
               },
               "end": {
                 "name": "U28",
                 "pin": "22"
               }
             },
             {
               "length": "30",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A4",
                 "pin": ""
               },
               "end": {
                 "name": "R682",
                 "pin": "2"
               }
             },
             {
               "length": "120",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A2",
                 "pin": ""
               },
               "end": {
                 "name": "U108",
                 "pin": "6"
               }
             },
             {
               "length": "50",
               "net": "SYSCTLR_I2C_SCL",
               "start": {
                 "name": "U108",
                 "pin": "3"
               },
               "end": {
                 "name": "A5",
                 "pin": ""
               }
             },
             {
               "length": "60",
               "net": "SYSCTLR_I2C_SCL",
               "start": {
                 "name": "A5",
                 "pin": ""
               },
               "end": {
                 "name": "U111",
                 "pin": "A15"
               }
             },
             {
               "length": "40",
               "net": "SYSCTLR_I2C_SCL",
               "start": {
                 "name": "A5",
                 "pin": ""
               },
               "end": {
                 "name": "R757",
                 "pin": "2"
               }
             }
           ]
         },
         {
           "signal": "SDA",
           "path": [
             {
               "length": "100",
               "net": "IIC_MAIN_SDA_LS",
               "start": {
                 "name": "U1",
                 "pin": "J25"
               },
               "end": {
                 "name": "A1",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA_LS",
               "start": {
                 "name": "A1",
                 "pin": ""
               },
               "end": {
                 "name": "R326",
                 "pin": "2"
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA_LS",
               "start": {
                 "name": "A1",
                 "pin": ""
               },
               "end": {
                 "name": "U77",
                 "pin": "4"
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "U77",
                 "pin": "5"
               },
               "end": {
                 "name": "A2",
                 "pin": ""
               }
             },
             {
               "length": "300",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "A2",
                 "pin": ""
               },
               "end": {
                 "name": "A3",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "A3",
                 "pin": ""
               },
               "end": {
                 "name": "U80",
                 "pin": "19"
               }
             },
             {
               "length": "80",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "A3",
                 "pin": ""
               },
               "end": {
                 "name": "A4",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "A4",
                 "pin": ""
               },
               "end": {
                 "name": "U28",
                 "pin": "23"
               }
             },
             {
               "length": "30",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "A4",
                 "pin": ""
               },
               "end": {
                 "name": "R683",
                 "pin": "2"
               }
             },
             {
               "length": "120",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "A2",
                 "pin": ""
               },
               "end": {
                 "name": "U108",
                 "pin": "5"
               }
             },
             {
               "length": "50",
               "net": "SYSCTLR_I2C_SDA",
               "start": {
                 "name": "U108",
                 "pin": "4"
               },
               "end": {
                 "name": "A5",
                 "pin": ""
               }
             },
             {
               "length": "60",
               "net": "SYSCTLR_I2C_SDA",
               "start": {
                 "name": "A5",
                 "pin": ""
               },
               "end": {
                 "name": "U111",
                 "pin": "D11"
               }
             },
             {
               "length": "40",
               "net": "SYSCTLR_I2C_SDA",
               "start": {
                 "id": "20005",
                 "name": "A5",
                 "pin": ""
               },
               "end": {
                 "name": "R758",
                 "pin": "2"
               }
             }
           ]
         }
       ]
     } */
    this.treeTempData = {
      "pcbId": "4435489278288",
      "log": [
        {
          "text": "",
          "type": "title"
        }
      ],
      "root": [
        "U1"
      ],
      "lengthUnit": "mil",
      "branch": [
        {
          "signal": "SCL",
          "path": [
            {
              "length": "100",
              "net": "IIC_MAIN_SCL_LS",
              "start": {
                "name": "U1",
                "pin": "J24"
              },
              "end": {
                "name": "U77",
                "pin": "3"
              }
            },
            {
              "length": "40",
              "net": "IIC_MAIN_SCL_LS",
              "start": {
                "name": "U77",
                "pin": "3"
              },
              "end": {
                "name": "R325",
                "pin": "2"
              }
            },
            {
              "length": "40",
              "net": "IIC_MAIN_SCL",
              "start": {
                "name": "U77",
                "pin": "6"
              },
              "end": {
                "name": "A2",
                "pin": ""
              }
            },
            {
              "length": "300",
              "net": "IIC_MAIN_SCL",
              "start": {
                "name": "A2",
                "pin": ""
              },
              "end": {
                "name": "A3",
                "pin": ""
              }
            },
            {
              "length": "40",
              "net": "IIC_MAIN_SCL",
              "start": {
                "name": "A3",
                "pin": ""
              },
              "end": {
                "name": "U80",
                "pin": "18"
              }
            },
            {
              "length": "80",
              "net": "IIC_MAIN_SCL",
              "start": {
                "name": "A3",
                "pin": ""
              },
              "end": {
                "name": "A4",
                "pin": ""
              }
            },
            {
              "length": "40",
              "net": "IIC_MAIN_SCL",
              "start": {
                "name": "A4",
                "pin": ""
              },
              "end": {
                "name": "U28",
                "pin": "22"
              }
            },
            {
              "length": "30",
              "net": "IIC_MAIN_SCL",
              "start": {
                "name": "A4",
                "pin": ""
              },
              "end": {
                "name": "R682",
                "pin": "2"
              }
            },
            {
              "length": "120",
              "net": "IIC_MAIN_SCL",
              "start": {
                "name": "A2",
                "pin": ""
              },
              "end": {
                "name": "U108",
                "pin": "6"
              }
            },
            {
              "length": "60",
              "net": "SYSCTLR_I2C_SCL",
              "start": {
                "name": "U108",
                "pin": "3"
              },
              "end": {
                "name": "U111",
                "pin": "A15"
              }
            },
            {
              "length": "40",
              "net": "SYSCTLR_I2C_SCL",
              "start": {
                "name": "U108",
                "pin": "3"
              },
              "end": {
                "name": "R757",
                "pin": "2"
              }
            }
          ]
        },
        {
          "signal": "SDA",
          "path": [
            {
              "length": "100",
              "net": "IIC_MAIN_SDA_LS",
              "start": {
                "name": "U1",
                "pin": "J25"
              },
              "end": {
                "name": "B1",
                "pin": ""
              }
            },
            {
              "length": "40",
              "net": "IIC_MAIN_SDA_LS",
              "start": {
                "name": "B1",
                "pin": ""
              },
              "end": {
                "name": "R326",
                "pin": "2"
              }
            },
            {
              "length": "40",
              "net": "IIC_MAIN_SDA_LS",
              "start": {
                "name": "B1",
                "pin": ""
              },
              "end": {
                "name": "U77",
                "pin": "4"
              }
            },
            {
              "length": "40",
              "net": "IIC_MAIN_SDA",
              "start": {
                "name": "U77",
                "pin": "5"
              },
              "end": {
                "name": "B2",
                "pin": ""
              }
            },
            {
              "length": "300",
              "net": "IIC_MAIN_SDA",
              "start": {
                "name": "B2",
                "pin": ""
              },
              "end": {
                "name": "B3",
                "pin": ""
              }
            },
            {
              "length": "40",
              "net": "IIC_MAIN_SDA",
              "start": {
                "name": "B3",
                "pin": ""
              },
              "end": {
                "name": "U80",
                "pin": "19"
              }
            },
            {
              "length": "40",
              "net": "IIC_MAIN_SDA",
              "start": {
                "name": "B3",
                "pin": ""
              },
              "end": {
                "name": "U28",
                "pin": "23"
              }
            },
            {
              "length": "30",
              "net": "IIC_MAIN_SDA",
              "start": {
                "name": "U28",
                "pin": "23"
              },
              "end": {
                "name": "R683",
                "pin": "2"
              }
            },
            {
              "length": "120",
              "net": "IIC_MAIN_SDA",
              "start": {
                "name": "B2",
                "pin": ""
              },
              "end": {
                "name": "U108",
                "pin": "5"
              }
            },
            {
              "length": "50",
              "net": "SYSCTLR_I2C_SDA",
              "start": {
                "name": "U108",
                "pin": "4"
              },
              "end": {
                "name": "B5",
                "pin": ""
              }
            },
            {
              "length": "60",
              "net": "SYSCTLR_I2C_SDA",
              "start": {
                "name": "B5",
                "pin": ""
              },
              "end": {
                "name": "U111",
                "pin": "D11"
              }
            },
            {
              "length": "40",
              "net": "SYSCTLR_I2C_SDA",
              "start": {
                "name": "B5",
                "pin": ""
              },
              "end": {
                "name": "R758",
                "pin": "2"
              }
            }
          ]
        }
      ]
    }
    /*  this.treeTempData = {
       "pcbId": "4435489278288",
       "log": [
         {
           "text": "",
           "type": "title"
         }
       ],
       "root": [
         "U1"
       ],
       "lengthUnit": "mil",
       "branch": [
         {
           "signal": "SCL",
           "path": [
             {
               "length": "100",
               "net": "IIC_MAIN_SCL_LS",
               "start": {
                 "name": "U1",
                 "pin": "J24"
               },
               "end": {
                 "name": "U77",
                 "pin": "3"
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SCL_LS",
               "start": {
                 "name": "U77",
                 "pin": "3"
               },
               "end": {
                 "name": "R326",
                 "pin": "2"
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "U77",
                 "pin": "6"
               },
               "end": {
                 "name": "A2",
                 "pin": ""
               }
             },
             {
               "length": "300",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A2",
                 "pin": ""
               },
               "end": {
                 "name": "A3",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A3",
                 "pin": ""
               },
               "end": {
                 "name": "U80",
                 "pin": "18"
               }
             },
             {
               "length": "80",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A3",
                 "pin": ""
               },
               "end": {
                 "name": "A4",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A4",
                 "pin": ""
               },
               "end": {
                 "name": "U28",
                 "pin": "22"
               }
             },
             {
               "length": "30",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A4",
                 "pin": ""
               },
               "end": {
                 "name": "R682",
                 "pin": "2"
               }
             },
             {
               "length": "120",
               "net": "IIC_MAIN_SCL",
               "start": {
                 "name": "A2",
                 "pin": ""
               },
               "end": {
                 "name": "U108",
                 "pin": "6"
               }
             },
             {
               "length": "50",
               "net": "SYSCTLR_I2C_SCL",
               "start": {
                 "name": "U108",
                 "pin": "3"
               },
               "end": {
                 "name": "A5",
                 "pin": ""
               }
             },
             {
               "length": "60",
               "net": "SYSCTLR_I2C_SCL",
               "start": {
                 "name": "A5",
                 "pin": ""
               },
               "end": {
                 "name": "U111",
                 "pin": "A15"
               }
             },
             {
               "length": "40",
               "net": "SYSCTLR_I2C_SCL",
               "start": {
                 "name": "A5",
                 "pin": ""
               },
               "end": {
                 "name": "R757",
                 "pin": "2"
               }
             }
           ]
         },
         {
           "signal": "SDA",
           "path": [
             {
               "length": "100",
               "net": "IIC_MAIN_SDA_LS",
               "start": {
                 "name": "U1",
                 "pin": "J25"
               },
               "end": {
                 "name": "B1",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA_LS",
               "start": {
                 "name": "B1",
                 "pin": ""
               },
               "end": {
                 "name": "R325",
                 "pin": "2"
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA_LS",
               "start": {
                 "name": "B1",
                 "pin": ""
               },
               "end": {
                 "name": "U77",
                 "pin": "4"
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "U77",
                 "pin": "5"
               },
               "end": {
                 "name": "B2",
                 "pin": ""
               }
             },
             {
               "length": "300",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "B2",
                 "pin": ""
               },
               "end": {
                 "name": "B3",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "B3",
                 "pin": ""
               },
               "end": {
                 "name": "U80",
                 "pin": "19"
               }
             },
             {
               "length": "80",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "B3",
                 "pin": ""
               },
               "end": {
                 "name": "B4",
                 "pin": ""
               }
             },
             {
               "length": "40",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "B4",
                 "pin": ""
               },
               "end": {
                 "name": "U28",
                 "pin": "23"
               }
             },
             {
               "length": "30",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "B4",
                 "pin": ""
               },
               "end": {
                 "name": "R683",
                 "pin": "2"
               }
             },
             {
               "length": "120",
               "net": "IIC_MAIN_SDA",
               "start": {
                 "name": "B2",
                 "pin": ""
               },
               "end": {
                 "name": "U108",
                 "pin": "5"
               }
             },
             {
               "length": "50",
               "net": "SYSCTLR_I2C_SDA",
               "start": {
                 "name": "U108",
                 "pin": "4"
               },
               "end": {
                 "name": "B5",
                 "pin": ""
               }
             },
             {
               "length": "60",
               "net": "SYSCTLR_I2C_SDA",
               "start": {
                 "name": "B5",
                 "pin": ""
               },
               "end": {
                 "name": "U111",
                 "pin": "D11"
               }
             },
             {
               "length": "40",
               "net": "SYSCTLR_I2C_SDA",
               "start": {
                 "name": "B5",
                 "pin": ""
               },
               "end": {
                 "name": "R758",
                 "pin": "2"
               }
             }
           ]
         }
       ]
     } */
    /*  this.treeTempData = {
       "pcbId": "4408766818592",
       "root": [
         "U68"
       ],
       "lengthUnit": "mil",
       "branch": [
         {
           "signal": "SCL",
           "path": [{
             "length": "100",
             "net": "PD_MS_I2C1_SCL",
             "start": {
               "name": "U68",
               "pin": "27"
             },
             "end": {
               "name": "A1",
               "pin": ""
             }
           },
           {
             "length": "100",
             "net": "PD_MS_I2C1_SCL",
             "start": {
               "name": "A1",
               "pin": ""
             },
             "end": {
               "name": "R452",
               "pin": "2"
             }
           },
           {
             "length": "500",
             "net": "PD_MS_I2C1_SCL",
             "start": {
               "name": "A1",
               "pin": ""
             },
             "end": {
               "name": "R157",
               "pin": "1"
             }
           },
           {
             "length": "20",
             "net": "N17827086",
             "start": {
               "name": "R157",
               "pin": "2"
             },
             "end": {
               "name": "A2",
               "pin": ""
             }
           },
           {
             "length": "60",
             "net": "N17827086",
             "start": {
               "name": "A2",
               "pin": ""
             },
             "end": {
               "name": "R158",
               "pin": "2"
             }
           },
           {
             "length": "100",
             "net": "N17827086",
             "start": {
               "name": "A2",
               "pin": ""
             },
             "end": {
               "name": "J22",
               "pin": "1"
             }
           }]
         },
         {
           "signal": "SDA",
           "path": [{
             "length": "100",
             "net": "PD_MS_I2C1_SDA",
             "start": {
               "name": "U68",
               "pin": "28"
             },
             "end": {
               "name": "B1",
               "pin": ""
             }
           },
           {
             "length": "100",
             "net": "PD_MS_I2C1_SDA",
             "start": {
               "name": "B1",
               "pin": ""
             },
             "end": {
               "name": "R451",
               "pin": "2"
             }
           },
           {
             "length": "500",
             "net": "PD_MS_I2C1_SDA",
             "start": {
               "name": "B1",
               "pin": ""
             },
             "end": {
               "name": "R163",
               "pin": "1"
             }
           },
           {
             "length": "20",
             "net": "N17827086",
             "start": {
               "name": "R163",
               "pin": "2"
             },
             "end": {
               "name": "B2",
               "pin": ""
             }
           },
            {
             "length": "60",
             "net": "N17827086",
             "start": {
               "name": "B2",
               "pin": ""
             },
             "end": {
               "name": "R164",
               "pin": "2"
             }
           },
           {
             "length": "100",
             "net": "N17827086",
             "start": {
               "name": "B2",
               "pin": ""
             },
             "end": {
               "name": "J22",
               "pin": "3"
             }
           }]
         }
       ]
     } */
    /* this.treeTempData = {
      "pcbId": "4408766818592",
      "root": [
        "U68"
      ],
      "lengthUnit": "mil",
      "branch": [
        {
          "signal": "SCL",
          "path": [{
            "length": "100",
            "net": "PD_MS_I2C1_SCL",
            "start": {
              "name": "U68",
              "pin": "27"
            },
            "end": {
              "name": "A1",
              "pin": ""
            }
          },
          {
            "length": "100",
            "net": "PD_MS_I2C1_SCL",
            "start": {
              "name": "A1",
              "pin": ""
            },
            "end": {
              "name": "R452",
              "pin": "2"
            }
          },
          {
            "length": "500",
            "net": "PD_MS_I2C1_SCL",
            "start": {
              "name": "A1",
              "pin": ""
            },
            "end": {
              "name": "R157",
              "pin": "1"
            }
          },
          {
            "length": "20",
            "net": "N17827086",
            "start": {
              "name": "R157",
              "pin": "2"
            },
            "end": {
              "name": "R158",
              "pin": "2"
            }
          },
          {
            "length": "100",
            "net": "N17827086",
            "start": {
              "name": "R157",
              "pin": "2"
            },
            "end": {
              "name": "J22",
              "pin": "1"
            }
          }]
        },
        {
          "signal": "SDA",
          "path": [{
            "length": "100",
            "net": "PD_MS_I2C1_SDA",
            "start": {
              "name": "U68",
              "pin": "28"
            },
            "end": {
              "name": "B1",
              "pin": ""
            }
          },
          {
            "length": "100",
            "net": "PD_MS_I2C1_SDA",
            "start": {
              "name": "B1",
              "pin": ""
            },
            "end": {
              "name": "R451",
              "pin": "2"
            }
          },
          {
            "length": "500",
            "net": "PD_MS_I2C1_SDA",
            "start": {
              "name": "B1",
              "pin": ""
            },
            "end": {
              "name": "R163",
              "pin": "1"
            }
          },
          {
            "length": "20",
            "net": "N17827086",
            "start": {
              "name": "R163",
              "pin": "2"
            },
            "end": {
              "name": "R164",
              "pin": "2"
            }
          },
          {
            "length": "100",
            "net": "N17827086",
            "start": {
              "name": "R163",
              "pin": "2"
            },
            "end": {
              "name": "J22",
              "pin": "3"
            }
          }]
        }
      ]
    } */
  }

  set = (id, data) => {
    this.data.set(id, data);
  }

  getData = (id, pcbId) => {
    const data = this.data.get(id) || new Map();
    return data.get(pcbId);
  }

  initSchematicTree = async ({ id, treeData, pcbId, content, compPrefixLib, compPinMap, setupData, visibleSignals }) => {
    try {
      const data = this.data.get(id) || new Map();

      if (!treeData || !treeData.branch || !treeData.branch.length) {
        data.set(pcbId, null)
        this.data.set(id, data);
        return
      }

      let log = [];
      log.push("==> Loading and parsing signal trace data...")
      const { components = [], signals = [], powerNets = [] } = content;
      const newSignals = visibleSignals && visibleSignals.length ? signals.filter(it => visibleSignals.includes(it.name)) : JSON.parse(JSON.stringify(signals));
      let newComps = this.updateComponentTypes({ components, pcbId, compPrefixLib, compPinMap });
      const _powerNets = (powerNets || []).map(item => item.name);

      log.push("==> Parsing all signal paths...")
      const connections = this.decompose(treeData, { components: newComps, powerNets: _powerNets, visibleSignals })
      log.push("==> Calculating the positions of all paths...")
      const { layoutNodes, layoutPaths, layoutComps, nodes, bounds, netsMaxLength, unitSize, parallelComps, unusedCompNodes } = this.processData({
        connections,
        treeData
      },
        { components: newComps, signals: newSignals, powerNets: _powerNets, visibleSignals })
      log.push("==> All signal paths have been created, ready to draw the schematic diagram...")
      data.set(pcbId, {
        components,
        powerNets: _powerNets,
        signals,
        connections,
        treeData,
        layoutNodes,
        layoutComps,
        nodes,
        layoutPaths,
        bounds,
        unitSize,
        setupData,
        netsMaxLength,
        parallelComps,
        unusedCompNodes,
        roots: treeData.root || [],
        visibleSignals: Array.from(visibleSignals || []),
        log: [...log.map(item => ({ id: "schematic", log: item }))]
      });
      this.data.set(id, data);
    } catch (error) {
      console.error(error)
    }
  }

  updateSchematicTree = ({ id, signals, pcbId }) => {
    try {
      const allPcbData = this.data.get(id);
      if (!allPcbData) {
        return;
      }
      const data = allPcbData.get(pcbId);

      if (!data) {
        return
      }

      let log = [];
      const newSignals = data.signals.filter(it => signals.includes(it.name));
      const connections = this.decompose(data.treeData, { components: data.components, powerNets: data.powerNets, visibleSignals: signals })
      log.push("==> Re Calculating the positions of all paths...")
      const { layoutNodes, layoutPaths, layoutComps, nodes, bounds, netsMaxLength, unitSize, parallelComps, unusedCompNodes } = this.processData({
        connections,
        treeData: data.treeData
      }, {
        components: data.components,
        signals: newSignals,
        powerNets: data.powerNets,
        visibleSignals: [...signals],
      })
      log.push("==>Re-create signal paths - all signal paths have been created, ready to draw the schematic diagram...")
      allPcbData.set(pcbId, {
        ...data,
        signals: data.signals,
        connections,
        layoutNodes,
        layoutComps,
        nodes,
        layoutPaths,
        bounds,
        unitSize,
        netsMaxLength,
        parallelComps,
        unusedCompNodes,
        visibleSignals: [...signals],
        log: [...log.map(item => ({ id: "schematic", log: item }))]
      });
      this.data.set(id, allPcbData);
    } catch (error) {
      console.error(error)
    }
  }

  updateComponentTypes = ({ components, pcbId, compPrefixLib, compPinMap }) => {
    let comps = JSON.parse(JSON.stringify(components || []));
    const passiveTable = pcbId ? compTableHelper.get(pcbId) : [];
    for (let comp of comps) {
      if (comp.type !== UNUSED) {
        continue;
      }
      //ignore to unused
      const type = comp.type === IGNORE ? UNUSED : comp.type;
      const pinList = auroraDBJson.getCompPinList(pcbId, comp.name);
      const allPinsLength = pinList.length;

      let compType = type;
      const findPassive = passiveTable.find(item => item.part === comp.part);
      if (findPassive && findPassive.usage) {
        compType = findPassive.usage;
      } else {
        compType = getCompType({
          compName: comp.name,
          pinLength: allPinsLength,
          COMP_PREFIX_LIB: compPrefixLib,
          partName: comp.part,
          product: SIERRA,
          compPinMap: compPinMap
        })
      }

      if (![UNUSED, IGNORE].includes(compType) && ![UNUSED, IGNORE].includes(type) && compType !== type) {
        //compType === Res, type === Cap
        compType = type;
      }
      comp.type = compType;
    }
    return comps;
  }

  getSchematicTreeNeedData = (setupData) => {
    return getInterfaceSetupInfo(setupData)
  }

  judgeUpdate = (prevData, newData) => {
    if (_.isEqual(prevData, newData)) {
      return true;
    }
  }

  // decompose all path
  decompose = (data, { components, powerNets, visibleSignals }) => {
    const decomposer = new PathDecomposer(data, components, powerNets, visibleSignals);
    const result = decomposer.decompose();
    return result;
  }

  processData = (tree, interfaceData) => {
    const { components, powerNets, signals, visibleSignals } = interfaceData || {};
    const connections = tree.connections;
    const treeData = tree.treeData;
    let compMap = new Map();
    for (let comp of components) {
      compMap.set(comp.name, comp);
    }

    const calculatePathPosition = new CalculatePathPosition({
      data: connections,
      treeData,
      compMap,
      powerNets,
      signals: signals || [],
      visibleSignals
    });
    calculatePathPosition.calculatePath();
    return calculatePathPosition.getResults();
  }

  clearPCBCache = (id, pcbId) => {
    const data = this.data.get(id) || new Map();
    data.delete(pcbId);
  }
}


const schematicTreeData = new SchematicTreeData();
export default schematicTreeData;